var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
      _vm._v(" "),
      _vm.delegatedAid
        ? _c("radio-button-option-row", {
            key: _vm.radioButtonValueChanged,
            attrs: {
              title: "BudgetaryEstimate.Delegation.IsAidDelegated",
              required: true,
              disabled: !_vm.hasProcuration,
              options: _vm.delegationOptions
            },
            model: {
              value: _vm.delegatedAid.delegatedTo,
              callback: function($$v) {
                _vm.$set(_vm.delegatedAid, "delegatedTo", $$v)
              },
              expression: "delegatedAid.delegatedTo"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.delegatedAid.delegatedTo == _vm.DelegationOption.DelegatedToMember
        ? _c(
            "div",
            [
              _c("numeric-input-row", {
                attrs: {
                  title: "BudgetaryEstimate.Delegation.TargetAmount",
                  id: "delegation-targetamount",
                  required: true
                },
                model: {
                  value: _vm.delegatedAid.amountOfTargets,
                  callback: function($$v) {
                    _vm.$set(_vm.delegatedAid, "amountOfTargets", $$v)
                  },
                  expression: "delegatedAid.amountOfTargets"
                }
              }),
              _vm._v(" "),
              _c("min-max-input-row", {
                attrs: {
                  title: "BudgetaryEstimate.Delegation.SumMinMax",
                  delegatedAid: _vm.delegatedAid,
                  required: true
                }
              }),
              _vm._v(" "),
              _c("estimates-control", {
                attrs: {
                  id: "member-delegation",
                  titleKey: "BudgetaryEstimate.Delegation.Member",
                  instructionsKey:
                    "BudgetaryEstimate.Delegation.Member_Instructions",
                  showRowTotals: true,
                  required: true
                },
                model: {
                  value: _vm.memberEstimates,
                  callback: function($$v) {
                    _vm.memberEstimates = $$v
                  },
                  expression: "memberEstimates"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.delegatedAid.delegatedTo == _vm.DelegationOption.DelegatedToPartner
        ? _c(
            "div",
            [
              _c("estimates-control", {
                attrs: {
                  id: "partner-delegation",
                  titleKey: "BudgetaryEstimate.Delegation.Partner",
                  tableKey: "BudgetaryEstimate.Delegation.DelegatedTo",
                  instructionsKey:
                    "BudgetaryEstimate.Delegation.Partner_Instructions",
                  addButtonKey: "BudgetaryEstimate.Delegation.AddPartner",
                  createEstimate: _vm.createEstimate,
                  required: true,
                  showActions: true,
                  showColumnTotals: true,
                  showRowTotals: true,
                  maxRows: 10
                },
                model: {
                  value: _vm.partnerEstimates,
                  callback: function($$v) {
                    _vm.partnerEstimates = $$v
                  },
                  expression: "partnerEstimates"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }